import type { IUser } from '@modules/user/types';

import ServerBaseError from './ServerBaseError';

export default class ServerUnauthorizedError extends ServerBaseError {
  public redirect_to_supervision: boolean;

  public currentUser: IUser;

  constructor(user: IUser, redirect_to_supervision = false, message = 'User is unauthorized or banned', showErrorPage = false) {
    super(message, showErrorPage);
    this.currentUser = user;
    this.redirect_to_supervision = redirect_to_supervision;
  }
}
